import clinicModule from "@/core/modules/CrudModule.js";

/*
 * Payment gateway adapter.
 *
 * Xenor credentials, request signatures, and webhook verification MUST live in
 * medhop-api-saas. The browser only calls Medhop's authenticated backend route.
 * This keeps the existing gateway active until Xenor is explicitly enabled.
 */
const configuredProvider = (process.env.VUE_APP_PAYMENT_PROVIDER || "legacy").toLowerCase();
const isXenor = configuredProvider === "xenor";
const legacyRoute = "subscription/invoices";
const xenorRoute = process.env.VUE_APP_XENOR_CREATE_INVOICE_ROUTE || "";
const xenorInvoiceRoute = process.env.VUE_APP_XENOR_INVOICE_ROUTE || "";
const xenorStatusRoute = process.env.VUE_APP_XENOR_STATUS_ROUTE || "";

function checkoutReference() {
  return `MEDHOP-${Date.now()}-${Math.random().toString(36).slice(2, 9).toUpperCase()}`;
}

function xenorInvoiceId(invoice) {
  return (
    invoice.xenor_id ||
    invoice.provider_invoice_id ||
    invoice.external_id ||
    invoice.invoice_id ||
    invoice.id
  );
}

function resolveRoute(template, id, settingName) {
  if (!template) {
    throw new Error(`Endpoint ${settingName} Xenor belum dikonfigurasi.`);
  }
  return template.replace("{id}", encodeURIComponent(id));
}

export default {
  provider: isXenor ? "xenor" : "legacy",
  label: isXenor ? "Xenor" : "Medhop Payment",

  async createInvoice(payment) {
    if (isXenor && !xenorRoute) {
      throw new Error(
        "Endpoint Xenor belum dikonfigurasi. Hubungi administrator pembayaran."
      );
    }

    const payload = {
      plan_version_id: payment.id,
      duration: payment.duration,
      payment_method_code: payment.payment_method_code,
      payment_method_category: payment.payment_method_category,
      payment_gateway: isXenor ? "xenor" : "legacy",
      checkout_reference: checkoutReference(),
    };

    return clinicModule.submit(payload, isXenor ? xenorRoute : legacyRoute);
  },

  normalizeInvoice(response, payment) {
    const responseData =
      response && response.success && response.success.data
        ? response.success.data
        : null;

    if (!responseData) return null;

    return Object.assign({}, responseData, {
      url_image: payment.url_image,
      payment_method_name: payment.payment_method_name,
      payment_gateway: isXenor ? "xenor" : "legacy",
    });
  },

  getInvoice(invoice) {
    const id = isXenor ? xenorInvoiceId(invoice) : invoice.xendit_id;
    const route = isXenor
      ? resolveRoute(xenorInvoiceRoute, id, "detail invoice")
      : `subscription/invoices/${encodeURIComponent(id)}`;
    return clinicModule.get(route);
  },

  checkPayment(invoice) {
    const id = isXenor ? xenorInvoiceId(invoice) : invoice.xendit_id;
    const route = isXenor
      ? resolveRoute(xenorStatusRoute, id, "status pembayaran")
      : `subscription/invoices/${encodeURIComponent(id)}/status`;
    return clinicModule.get(route);
  },
};
